import MobileOopsPage from "./MobileOopsPage";

export default MobileOopsPage;
